import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { candidacyInfoQueryKey } from "@/hooks/queries/useGetCandidacyInfo";
import { guacHttpClient } from "@/lib/http";
import { HttpResponse } from "@/types";

interface StafferNudgeResponse {
  sourcedCandidacyId: string;
  sentAt: string;
}

// Has Sally text a converted candidate that the staffer has been trying to
// reach them. One templated message from Sally's line. Sally does not reopen.
export function useNudgeViaSally() {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      candidacyId,
    }: {
      candidacyId: string;
      // The thread the text lands in, so it can be refreshed right away
      // rather than on the next 10s poll.
      talentId: number | null;
    }) => {
      const res = await guacHttpClient.post<
        StafferNudgeResponse,
        HttpResponse<StafferNudgeResponse>
      >("sourcing-agent-conversations/staffer-nudge", { candidacyId });
      return res.data;
    },
    onSuccess: (_, { candidacyId, talentId }) => {
      // The sheet shows "nudged Xh ago" and disables the item for 24h.
      void queryClient.invalidateQueries({
        queryKey: candidacyInfoQueryKey(
          currentCompanyId,
          currentJobId,
          candidacyId,
        ),
      });
      // Sally's text shows in the candidate's thread without waiting on the poll.
      void queryClient.invalidateQueries({
        queryKey: ["quo-messages", talentId],
      });
    },
  });
}
